import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';

const getInitials = (name, email) => {
  if (name) {
    const parts = name.split(' ').filter(Boolean);
    if (parts.length === 0) return email ? email[0].toUpperCase() : '?';
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return email ? email[0].toUpperCase() : '?';
};

const InitialsAvatar = ({ name, email, size = 32, sx = {} }) => (
  <Avatar
    sx={{
      width: size,
      height: size,
      fontSize: size * 0.4375,
      bgcolor: 'secondary.main',
      color: 'primary.main',
      ...sx,
    }}
  >
    {getInitials(name, email)}
  </Avatar>
);

InitialsAvatar.propTypes = {
  name: PropTypes.string,
  email: PropTypes.string,
  size: PropTypes.number,
  sx: PropTypes.object,
};

export default InitialsAvatar;
